import type { Moment } from 'moment'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

import BodyText from 'LuxKit/Typography/BodyText'
import { SHORT_DAY_NAME_DAY_MONTH_YEAR } from 'constants/dateFormats'
import { useRegionTimeFormat } from 'hooks/useRegionTimeFormat'

const DateTime = styled.div`
  display: flex;
  flex-direction: column;
  font-weight: ${(props) => props.theme.font.primary.weight.regular};
  font-size: ${rem(14)};
  line-height: ${rem(24)};
`

type Props = {
  title: string
  date?: Moment
  time?: Moment
  day?: number
}

function DateTimeBlock({ title, date, time, day }: Props) {
  const timeFormat = useRegionTimeFormat()

  if (!date && !time && !day) return null

  return (
    <DateTime>
      <BodyText variant="medium" weight="bold">
        {title}
      </BodyText>
      {day && <BodyText variant="large">Day {day}</BodyText>}
      {!day && date && (
        <BodyText variant="large">
          {date?.format(SHORT_DAY_NAME_DAY_MONTH_YEAR)}
        </BodyText>
      )}
      {time && <BodyText variant="large">{time?.format(timeFormat)}</BodyText>}
    </DateTime>
  )
}

export default DateTimeBlock
